import { createSlice } from '@reduxjs/toolkit';
import { openModal, closeModal } from '../actions';

export type CurrentModalState = boolean;

const initialState: CurrentModalState = false;

const currentModalSlice = createSlice({
  name: 'currentModal',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(openModal, () => true).addCase(closeModal, () => false);
  },
});

export const currentModalReducer = currentModalSlice.reducer;
